import { useMemo, useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viCheck, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddMemberItem({ member, intercom, intercomDispatch }) {
  const [pending, setPending] = useState(false);

  const isActive = useMemo(
    () => !!intercom.members.find((_user) => _user.id === member.id),
    [intercom.members, member.id],
  );

  const disableItem = useMemo(() => !isActive && intercom.members.length >= 15, [intercom.members.length, isActive]);

  const addMember = () => {
    setPending(true);

    if (isActive) {
      Promise.resolve(Api.deleteIntercomMember(intercom, member))
        .then(() => intercomDispatch({ type: "removeMember", sippeerId: member.id }))
        .finally(() => setPending(false));
    } else {
      Promise.resolve(Api.postIntercomMember(intercom, member))
        .then(() => intercomDispatch({ type: "addMember", member }))
        .finally(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton onClick={addMember} disabled={pending || disableItem} sx={{ minHeight: 44 }}>
        <ListItemAvatar>
          <Avatar text={member.name} />
        </ListItemAvatar>
        <ListItemText primary={member.name} secondary={member.exten} />
        {(pending || isActive) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddMemberItem.propTypes = {
  member: PropTypes.object,
  intercom: PropTypes.object,
  intercomDispatch: PropTypes.func,
};

export default AddMemberItem;
